import React from 'react';
import { usePathname } from 'next/navigation';
import * as S from './Header.styles';
import { HeaderProps } from './Header.types';
import { HeaderLeftAction } from './components/HeaderLeftAction';
import { HeaderTitle } from './components/HeaderTitle';
import { DesktopHeaderCatalogue } from './components/DesktopHeaderCatalogue';
import { HeaderRightAction } from './components/HeaderRightAction';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import NoSsr from '@/components/NoSsr/NoSsr';
import { ROUTES } from '@/constants/routes';
import { SearchPanel } from '@/components/SearchPanel';
import { usePageType } from '@/hooks/usePageType/usePageType';
import { PageType } from '@/hooks/usePageType/usePageType.types';

export const Header = ({
  title,
  isMain,
  hasBurger,
  hasAddNew,
  rightAction,
}: HeaderProps) => {
  const { isDesktop } = useBreakpoint();
  const pathname = usePathname();
  const pageType = usePageType();
  const hasCatalogueAndSearchPanel =
    isDesktop &&
    ![PageType.NewAd, PageType.EditAd].includes(pageType) &&
    pathname !== ROUTES.businessLanding;

  return (
    <S.HeaderBox $isMain={isMain}>
      <S.HeaderContent data-testid={CommonTestIds.header.box} $isMain={isMain}>
        <NoSsr>
          <HeaderLeftAction hasBurger={isMain || hasBurger} />
          <HeaderTitle title={title} />
          {hasCatalogueAndSearchPanel && (
            <>
              <DesktopHeaderCatalogue />
              <SearchPanel />
            </>
          )}
          <HeaderRightAction
            isMain={isMain}
            hasAddNew={hasAddNew}
            rightAction={rightAction}
          />
        </NoSsr>
      </S.HeaderContent>
    </S.HeaderBox>
  );
};
